module.exports = __webpack_public_path__ + "distribution/img/kong2.a7dc4916.png";